/* JV Welcome Popup - tetikleyici, hatirlama, kopyalama, GA4 olaylari.
   Ayarlar sections/jv-welcome-popup.liquid icindeki data-* niteliklerinden okunur. */
(function () {
  var root = document.getElementById('JvWelcomePopup');
  if (!root) return;

  var KEY = 'jv_welcome_state';
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { state = {}; }

  function save(patch) {
    try {
      for (var k in patch) { state[k] = patch[k]; }
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function track(name, params) {
    params = params || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in params) { payload[k] = params[k]; }
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  var lastFocus = null;

  function openPopup(reason) {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var first = root.querySelector('input[type=email]') || root.querySelector('[data-jv-wp-copy]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    track('welcome_popup_view', { trigger: reason || 'auto' });
  }

  function closePopup() {
    root.classList.remove('is-open');
    root.hidden = true;
    document.body.style.overflow = '';
    save({ dismissedAt: Date.now() });
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-jv-wp-close]')) { e.preventDefault(); closePopup(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closePopup();
  });

  var copyBtn = root.querySelector('[data-jv-wp-copy]');
  if (copyBtn) {
    var label = copyBtn.textContent;
    copyBtn.addEventListener('click', function () {
      var el = root.querySelector('[data-jv-wp-code]');
      var code = el ? (el.textContent || '').trim() : '';
      var done = function () {
        copyBtn.textContent = copyBtn.getAttribute('data-copied-label') || 'Copied';
        setTimeout(function () { copyBtn.textContent = label; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        done();
      }
    });
  }

  /* Abonelik sonrasi: sayfa yenilendi, kod ekrani basildi -> hemen ac. */
  if (root.querySelector('[data-jv-wp-success]')) {
    save({ subscribed: true });
    openPopup('success');
    track('newsletter_signup', { list: 'welcome_popup' });
    return;
  }

  if (state.subscribed) return;

  var path = window.location.pathname;
  if (/^\/(cart|checkout|account)/.test(path)) return;
  if (/first-look|wholesale|become-a-retailer|line-sheet|catalog/.test(path)) return;
  if (window.location.search.indexOf('jv_nopopup=1') > -1) return;

  var cooldown = (parseInt(root.getAttribute('data-cooldown'), 10) || 30) * 86400000;
  if (state.dismissedAt && (Date.now() - state.dismissedAt) < cooldown) return;

  var fired = false;
  var timer = null;

  function cleanup() {
    if (timer) clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseleave', onLeave);
  }

  function trigger(reason) {
    if (fired) return;
    fired = true;
    cleanup();
    openPopup(reason);
  }

  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && (window.scrollY / h) * 100 >= pct) trigger('scroll');
  }

  function onLeave(e) {
    if (e.clientY <= 0) trigger('exit_intent');
  }

  var delay = (parseInt(root.getAttribute('data-delay'), 10) || 15) * 1000;
  var pct = parseInt(root.getAttribute('data-scroll'), 10) || 50;

  timer = setTimeout(function () { trigger('delay'); }, delay);
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('mouseleave', onLeave);
})();
